<script>
import _ from 'lodash'
import service from '@/request/base'
import UserService from '@/request/user/user'
import UserInfoService from '@/request/user/userInfo'
import OrgUserService from '@/request/user/orguser'
const logo = require('@/assets/logo.png')
export default {
  name: 'UserDoctorInfo',
  components: {},
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      user: {},
      info: {},
      orgs: [],
      showFull: false
    }
  },
  computed: {},
  created: function () {
    this.loadUser()
    this.loadUserInfo()
    this.listOrg()
  },
  watch: {},
  methods: {
    loadUser () {
      if (!this.id) {
        return
      }
      UserService.load({
        id: this.id
      }).then(res => {
        this.user = _.clone(res.result || {})
      })
    },
    loadUserInfo () {
      if (!this.id) {
        return
      }
      UserInfoService.load({
        uid: this.id
      }).then(res => {
        this.info = _.clone(res.result || {})
      })
    },
    listOrg () {
      if (!this.id) {
        return
      }
      OrgUserService.list({
        uids: this.id
      }).then(res => {
        this.orgs = _.clone(res.result || [])
      })
    }
  },
  filters: {
    headimgFilter (value) {
      if (!value) {
        return logo
      }
      return service.url(value)
    }
  }
}
</script>

<template>
  <div class="doctor-container">
    <div class="base-info">
      <div class="well clear">
        <div class="row title">
          <span class="doctor-name">{{user.name}}</span>
          <span class="doctor-sex">{{user.sex && user.sex % 2 === 0 ? '女' : '男'}}</span>
        </div>
        <div class="row">
          <span class="doctor-org" v-for="(org, index) in orgs" :key="index">
            {{org.oname}}
          </span>
        </div>
      </div>
    </div>
    <div class="more-info">
      <div class="well">
        <div class="info-content">
          <div class="wrap clear">
            <div class="header-img fl">
              <img :src="user.pic | headimgFilter">
            </div>
            <div class="doctor-describe fl" :class="{full: showFull}">
              <span class="label">介绍</span>
              <p>{{info.describe || '医生还没有介绍自己'}}</p>
              <div class="btns">
                <a href="javascript:void(0)" @click="showFull = !showFull">
                  <span v-if="!showFull">点击查看更多 <i class="el-icon-arrow-down"></i></span>
                  <span v-else>点击隐藏 <i class="el-icon-arrow-up"></i></span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.doctor-container {
  width: 100%;
  height: 100%;
}
.well {
  padding: 0 16px;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
}
.row {
  width: 100%;
  margin: 10px 0;
}
.wrap {
  width: 100%;
  height: 100%;
  position: relative;
}
.label {
  color: #9B9B9B;
  font-size: 18px;
  line-height: 30px;
}
.base-info .title {
}
.base-info .doctor-name,
.base-info .doctor-sex {
  font-size: 30px;
  line-height: 30px;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 20px;
}
.base-info .doctor-sex {
  color: #5f9cec;
}
.info-content {
  border-top: 1px solid #e1e6eb;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
}
.info-content .header-img {
  width: 80px;
  height: 105px;
  position: absolute;
  top: 10px;
  left: 0;
  z-index: 1;
}
.info-content .header-img img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 0;
  display: block;
  margin: auto;
  padding: auto;
}
.info-content .doctor-describe {
  width: 100%;
  min-height: 200px;
  padding: 10px 0 10px 100px;
  font-size: 14px;
  line-height: 1.8;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
}
.info-content .doctor-describe p {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
  -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
  -webkit-line-clamp: 3; /** 显示的行数 **/
  overflow: hidden;  /** 隐藏超出的内容 **/
}
.info-content .doctor-describe.full p {
  display: block;
}
.btns {
  padding: 5px 0px;
  font-size: 14px;
  line-height: 20px;
  text-align: right;
  text-decoration: none;
}
</style>
